import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { advancedRequestSchemaObject } from '../advancedRequestSchema'
import { validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import authService from '../../Common/services';
import MaterialTable, { MTableBody } from "material-table";
import { Grid } from '@material-ui/core';
import tokenService from "../../../Common/tokenDecoder";
import { Checkbox } from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import { trackPromise } from "react-promise-tracker";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

const screenCode = 'ADVANCEDREQUEST';

export function AdvancedRequestApprovalDetailListing(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            '& > *': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },
    }));
    const classes = useStyles();
    const { data, edit } = props.location
    const [title, setTitle] = useState("Advance Request Approve")
    const [isChanged, setIsChanged] = useState(0)
    const [isViewButton, setIsViewButton] = useState(true);
    const [isEditHide, setisEditHide] = useState(false);
    const [group, setGroup] = useState({
        advancedRequestID: "",
        approvedAmount: '',
        collectionPointID: "",
        collectionPointName: "",
        createdDate: "",
        firstName: "",
        registrationNumber: "",
        requestedAmount: "",
        statusID: "",
        reason: ""
    });
    const [search, setSearchForm] = useState({
        collectionPointID: 0,
        groupID: 0,
        operationEntityID: 0
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        checkDisbursement();
    }, [group.reason]);

    useEffect(() => {
        trackPromise(
            actionButtonEnable()
        )
    }, [group.statusID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITADVANCEDREQUEST');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        if (edit) {
            setTitle("Advance Request Approve");

            if (data.reason == undefined || data.reason == null) {
                setGroup({
                    ...data,
                    reason: ""
                });
            }
            else {
                setGroup(data);
            }
        }
    }

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [group]);

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'isActive' ? target.checked : target.value
        const error = { ...errors }
        const errorMessage = validateProperty(target, advancedRequestSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        setGroup({
            ...group,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleApprove(e) {
        e.preventDefault()
        if (group.approvedAmount <= group.requestedAmount) {
            const response = await services.AdvancedRequestApprovalStatusUpdate(group.advancedRequestID, group.approvedAmount, group.reason)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        else {
            setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Invalid Approved Amount" })
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true })
            }, 1500);
        }
    }
    async function handleReject(e) {
        e.preventDefault()

        if (group.approvedAmount <= group.requestedAmount) {
            if (group.reason !== "") {
                const response = await services.AdvancedRequestRejectStatusUpdate(group.advancedRequestID, group.approvedAmount, group.reason)
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
                afterSuccessfulyChanged(response.statusCode)
            }
            else {
                setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Reason Required" })
                setTimeout(() => {
                    setMessageModel({ ...messageModel, hidden: true })
                }, 1500);
            }
        }
        else {
            setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Invalid Approved Amount" })
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true })
            }, 1500);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                props.history.push({ pathname: '/advancedRequest' })
            }, 1500);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function checkDisbursement() {
        if (group.reason === '') {
            setIsViewButton(true);
        }
        else {
            setIsViewButton(false);
        }
    }

    async function actionButtonEnable() {
        if (group.statusID == 'new') {
            setisEditHide(false)
        }
        else {
            setisEditHide(true)
        }
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/advancedRequest"
                        />
                        <form>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Date"
                                            name="createdDate"
                                            id="createdDate"
                                            value={group.createdDate}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["createdDate"] && <span id="errbranchCode" className="text text-danger">{errors["createdDate"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Collection Point"
                                            name="ordercollectionPointNameNumber"
                                            id="collectionPointName"
                                            value={group.collectionPointName}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["collectionPointName"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointName"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="RegNo"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={group.registrationNumber}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["registrationNumber"] && <span id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</span>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Customer Name"
                                            name="firstName"
                                            id="firstName"
                                            value={group.firstName}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["firstName"] && <span id="errbranchCode" className="text text-danger">{errors["firstName"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Requested Amount"
                                            name="requestedAmount"
                                            id="requestedAmount"
                                            value={group.requestedAmount}
                                            type="text"
                                            disabled={true}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["requestedAmount"] && <span id="errbranchCode" className="text text-danger">{errors["requestedAmount"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Approve Amount *"
                                            name="approvedAmount"
                                            id="approvedAmount"
                                            value={group.approvedAmount}
                                            type="text"
                                            disabled={isEditHide}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["approvedAmount"] && <FormHelperText id="approvedAmount" className="text text-danger">{errors["approvedAmount"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Reason"
                                            name="reason"
                                            id="reason"
                                            value={group.reason}
                                            type="text"
                                            disabled={isEditHide}
                                            onChange={(e) => handleChange(e)} />
                                        {errors["reason"] && <FormHelperText id="reason" className="text text-danger">{errors["reason"]}</FormHelperText>}
                                    </div>
                                </div>
                                <br />
                            </div>
                            <div className="card-footer">
                                <input
                                    type="submit"
                                    value="approve"
                                    className="btn btn-primary"
                                    onClick={handleApprove}
                                    hidden={isEditHide}
                                />
                                <input
                                    type="submit"
                                    value="Reject"
                                    className="btn btn-warning pull-right"
                                    onClick={handleReject}
                                    hidden={isEditHide}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}